import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as contractActions from "../../actions/contractActions";
import * as customerActions from "../../actions/customerActions";
import * as userActions from "../../actions/userActions";
import * as codeActions from "../../actions/codeActions";
import * as contractTierActions from "../../actions/contractTierActions";

import HeaderWrapper from "../common/HeaderWrapper";
import Alert from "../common/Alert";
import ContractForm from "./ContractForm";

class ContractEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, editing: false };
  }

  componentDidMount = () => {
    const { customers, users, match, actions, contractTiers } = this.props;

    actions.getContract(match.params.id);

    if (!customers.length) actions.loadCustomers();
    if (!users.length) actions.loadUsers();
    if (!contractTiers.length) actions.loadContractTiers();
  };

  componentWillUnmount = () => {
    this.props.actions.clearContract();
  };

  handleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  handleSave = (contract) => {
    this.props.actions.updateContract(contract, false);
  };

  handleCancel = () => {
    this.props.history.goBack();
  };

  render() {
    const {
      contract,
      customers,
      users,
      codes,
      saving,
      isMobile,
      auth,
      contractTiers
    } = this.props;
    const { editing } = this.state;
    return (
      <React.Fragment>
        <HeaderWrapper
          breadcrumbs={[{ label: contract.name }]}
          // only allow edit if billing admin, ceo, or admin
          onClickEdit={
            (auth.maxRole === 4000 || auth.maxRole >= 8000) && this.handleEdit
          }
          isMobile={isMobile}
        />
        <div style={{ margin: "15px 15px 0 15px" }}>
          <Alert show={contract?.customer?.bc_blocked === "All"}>
            <p>This customer’s account has been blocked in Business Central</p>
          </Alert>
        </div>
        <div className="content-wrapper">
          <ContractForm
            contract={contract}
            customers={customers}
            codes={codes}
            users={users}
            editing={editing}
            saving={saving}
            contractTiers={contractTiers}
            onSave={this.handleSave}
            onCancel={this.handleCancel}
          />
        </div>
      </React.Fragment>
    );
  }
}

ContractEditPage.propTypes = {
  actions: PropTypes.object.isRequired,
  contract: PropTypes.object.isRequired,
  customers: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  codes: PropTypes.array.isRequired,
  auth: PropTypes.object,
  match: PropTypes.object,
  saving: PropTypes.bool,
  isMobile: PropTypes.bool,
  history: PropTypes.object,
  contractTiers: PropTypes.array
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    contract: state.reducers.contract,
    customers: state.reducers.customers,
    saving: state.reducers.savingContract,
    users: state.reducers.users,
    codes: state.reducers.codes,
    auth: state.reducers.auth,
    contractTiers: state.reducers.contractTiers
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...contractActions,
        ...customerActions,
        ...userActions,
        ...codeActions,
        ...contractTierActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ContractEditPage);
